<div class="row step">
  <div class="col-1 col-sm-2 col-md-4" aria-hidden="true"><hr /></div>
  <div class="cold-10 col-sm-8 col-md-4">
    <div class="step-number-container">
      <div
        class="step-number"
        [ngClass]="{
          'step-number-active': isActive,
          'step-number-end': isLastStep
        }"
      >
      <!-- commented in case we want to re-integrate tick icon as last step -->
      <!-- @if(isLastStep) {
        <mat-icon aria-hidden="true">done</mat-icon>
        <span class="visually-hidden">{{ stepNumber }}</span>
      } @else { -->
        <span>
          <span class="visually-hidden">Step </span>{{ stepNumber }}@if (totalSteps) {<span class="visually-hidden"> of {{ totalSteps }}</span>}
        </span>
      <!-- } -->

      </div>
    </div>

  </div>
  <div class="col-1 col-sm-2 col-md-4" aria-hidden="true"><hr /></div>
</div>
<div class="row">
  <div class="col-sm-12">
    <p class="step-title">
      @if (isActive) {<span class="visually-hidden">Current step: </span>}{{stepTitle}}
    </p>
  </div>
</div>
